import { getRegisterFunction } from '../../utils/register.js';
import { OneUxToastElement } from './OneUxToastElement.js';
export const register = getRegisterFunction(OneUxToastElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-toast': OneUxToastElement;
    "toast-32bd7366e8db11b27763180e3020fff5": OneUxToastElement;
  }
}